<template>
  <div class="moeco-partner-block-container">
    <div class="logo-container">
      <img src="/icons/moeco-logo.svg" alt="" class="logo" />
    </div>
    <div class="content-block">
      <div v-if="status != 'connected'">
        <div class="title">
          {{ $t("moeco_block.title") }}
        </div>
        <div v-if="status == 'initial'" class="data-block">
          <div class="info-text">
            {{ $t("moeco_block.comment") }}
          </div>
          <div class="info-text">
            {{ $t("moeco_block.comment_2") }}
          </div>
        </div>
        <div v-else-if="status == 'sent'" class="data-block">
          <div class="info-text">
            {{ $t("moeco_block.request_sent") }}
          </div>
        </div>
        <DashboardButton @click="connect" :disabled="busy" v-if="status != 'sent'" variant="moeco">{{
          $t("moeco_block.connect_btn")
        }}</DashboardButton>
      </div>
      <div v-else>
        <div class="label">
          {{ $t("moeco_block.ready_title") }}
        </div>
        <div class="data-block">
          <CircleToggle
            :value="cafe.delivery.is_smart"
            @input="setSmartDelivery(true)"
            class="iqos-checkbox"
          >
            {{ $t("moeco_block.smart_option") }}</CircleToggle
          ><CircleToggle
            :value="!cafe.delivery.is_smart"
            @input="setSmartDelivery(false)"
            class="iqos-checkbox"
          >
            {{ $t("moeco_block.manual_option") }}
          </CircleToggle>
          <p class="comment c-grey" v-if="!cafe.delivery.is_smart">
            {{ $t("moeco_block.manual_desc") }}
          </p>
          <p class="comment c-grey" v-else>
            {{ $t("moeco_block.smart_desc") }}
          </p>
          <div class="label">
            {{ $t("moeco_block.price") }} {{ cafe.delivery.taxi_cost }} UAH
          </div>
          <p class="comment c-grey" v-if="cafe.delivery.target_orders_count">
            {{ $t('moeco_block.planned_count') }} {{ cafe.delivery.target_orders_count}}
          </p>
        </div>
        <DashboardButton @click="disconnect" :disabled="busy" v-if="status == 'connected'" variant="danger">{{
          $t("moeco_block.disconnect")
        }}</DashboardButton>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardButton from "@/components/DashboardButton.vue";
import CircleToggle from "@/components/CircleToggle.vue";

import MoecoAPI from "@/api/moeco";

export default {
  components: {
    DashboardButton,
    CircleToggle,
  },
  data() {
    return {
      busy: false
    }
  },
  methods: {
    setSmartDelivery(v) {
      this.$store.commit("setDeliverySmartFlag", v);
      this.$store.dispatch("saveCafe");
    },
    connect() {
      this.busy = true;

      MoecoAPI.connect(this.cafe._id)
        .then((data) => {
          this.busy = false;

          this.$store.commit("setDeliveryServiceData", {
            service_tag: "moeco",
            service_status: "pending",
          });
        })
        .catch((error) => {
          this.busy = false;
          alert(`Не вдалось підключити доставку: ${error}`);
        });
    },
    disconnect() {
      MoecoAPI.disconnect(this.cafe._id)
        .then((data) => {
          this.busy = false;

          this.$store.commit("setDeliveryServiceData", {
            service_tag: "qrwaiter",
            service_status: "ready",
          });
        })
        .catch((error) => {
          this.busy = false;
          alert(`Не вдалось відключити доставку: ${error}`);
        });
    }
  },
  computed: {
    status() {
      if (!this.serviceStatus) return "initial";

      return this.serviceStatus == "ready" ? "connected" : "sent";
    },
    cafe() {
      return this.$store.state.cafe;
    },
    serviceStatus() {
      if (this.cafe.delivery.service_tag != "moeco") return null;

      return this.cafe.delivery.service_status;
    },
  },
};
</script>
<style scoped>
.moeco-partner-block-container {
  border-radius: 1.37vh;
  margin-top: 3.333vh;
  background: #041532;
  width: 100%;
  display: flex;
  min-height: 26.444vh;
}
.logo-container {
  width: 48%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #5395ff;
  border-radius: 1.33vh 0 0 1.33vh;
}
.logo {
  width: 38.444vh;
}
.content-block {
  width: 52%;
  padding: 2.222vh;
}
.title {
  font-weight: normal;
  font-size: 2.777vh;
  line-height: 3.222vh;
  color: #ededed;
  padding-bottom: 0.555vh;
  width: 100%;
  border-bottom: 0.111vh solid #ededed;
}
.data-block {
  width: 100%;
  padding: 2.222vh 0;
}
.info-text {
  font-weight: normal;
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  margin-bottom: 2.222vh;
  color: #ededed;
}
.info-text:last-child {
  margin-bottom: 0;
}
.label {
  font-weight: normal;
  font-size: 2.22222vh;
  line-height: 2.5555555555555554vh;
  color: #ededed;
}
.comment {
  margin-top: 1.666vh;
}
</style>
